<template>
  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
    <div :class="className">
      <div class="text-h5 mb-2" v-if="title">{{ title }}</div>

      <div class="d-flex align-center px-0 pt-4" v-for="item in array" :key="item.title">
        <div><v-img class="mx-auto" :src="require(`@/assets/img/${img}.png`)" width="75px"></v-img></div>
        <div class="ml-4">
          <div class="text-lg-h6 text-md-h6 text-sm-h6 text-xs-subtitle-1 font-weight-medium">
            {{ item.title }}
          </div>
          <a @click.stop :href="item.link" class="link" target="_blank"> {{ item.text }}</a>
        </div>
      </div>
    </div>
  </v-col>
</template>

<script>
export default {
  name: "LegalCol",

  props: {
    array: {
      type: Array,
    },
    img: {
      type: String,
      default: "docs",
    },
    className: {
      type: String,
    },
    title: {
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
.link {
  text-decoration: none !important;
}
.link:hover {
  text-decoration: underline !important;
}
.partner {
  position: absolute;
  right: 0;
  @media (max-width: 960px) {
    position: initial;
  }
}
</style>
